import React from "react";
import VehicleForm from "../components/VehicleForm";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { useNavigate } from "react-router-dom";

export default function AddVehicle() {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate("/home");
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-semibold mb-4">Add New Vehicle</h1>
      <Card className="max-w-xl">
        <CardContent className="pt-6">
            <VehicleForm
                vehicle={null}
                onSuccess={handleSuccess}
                onCancel={() => navigate("/home")}
            />
        </CardContent>
      </Card>
    </div>
  );
}
